"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z.object({
    windMachineDetails: zod_1.z
        .object({
        lngLats: zod_1.z.string().array(),
    })
        .optional(),
    windMachineSettings: zod_1.z
        .object({
        lngLats: zod_1.z.string().array(),
        settings: zod_1.z.object({
            stop: zod_1.z.boolean().optional(),
            auto: zod_1.z
                .record(zod_1.z.literal(0).or(zod_1.z.literal(1)))
                .or(zod_1.z.literal(0))
                .or(zod_1.z.literal(1))
                .optional(),
            tempStart: zod_1.z.number().optional(),
            tempStop: zod_1.z.number().optional(),
            calibrate1: zod_1.z.number().optional(),
            calibrate2: zod_1.z.number().optional(),
            windMachine_make: zod_1.z.string().optional(),
            windMachine_engine: zod_1.z.string().optional(),
            rpmMultiplier: zod_1.z.number().optional(),
            rpmCalibration: zod_1.z.string().optional(),
            ctmEnabled: zod_1.z.boolean().optional(),
        }),
    })
        .optional(),
});
exports.path = '/wind-machine';
//# sourceMappingURL=index.js.map